module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools--employee"
  }, [(!_vm.item.assigned) ? _c('action', {
    attrs: {
      "icon": "add",
      "color": "green"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.signin.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('page.roster.tools.signin')))]) : _vm._e(), _vm._v(" "), (_vm.signedOut) ? _c('action', {
    attrs: {
      "icon": "check",
      "color": "green"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelSignout.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('page.roster.tools.work')))]) : _vm._e(), _vm._v(" "), (_vm.item.assigned && !_vm.signedOut) ? _c('action', {
    attrs: {
      "icon": "cancel",
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.signout.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('page.roster.tools.signout')))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-003555de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/tools/Employee.vue
// module id = 608
// module chunks = 234